import React from "react"
import { useLocation } from "react-router-dom"
import { Link } from "react-router-dom"

type MedMvaLinkProps = {
  preventScrollReset?: boolean
  children: React.ReactNode
  konto: number
}
export default function SearchKeywordLink({
  children,
  preventScrollReset = true,
  konto,
}: MedMvaLinkProps): React.ReactElement {
  const search = `sok=${konto}`
  const { pathname } = useLocation()
  const to = {
    pathname,
    search,
  }
  return (
    <Link preventScrollReset={preventScrollReset} to={to}>
      {children}
    </Link>
  )
}
